// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FastCommentButton_wrapper__9usFy","text":"FastCommentButton_text__3rk2B"};